import {useDispatch} from 'react-redux'
import {TableList} from '../../Components/TableList/TableList'
import {type CertificateType} from '../../Store/DataSlice'
import {setDestinationView} from '../../Store/InterfaceSlice'

interface CertificateTypeTableProps {
    certificateTypes: CertificateType[]
    isLoading: boolean
}

export function CertificateTypeTable({
                                         certificateTypes,
                                         isLoading,
                                     }: CertificateTypeTableProps) {
    const dispatch = useDispatch()

    return (
        <TableList
            tableType="certificate-type"
            items={certificateTypes}
            configurations={{
                name: {
                    label: 'Naam',
                    show: true,
                },
                isActive: {
                    label: 'Is actief',
                    show: true,
                    getValue: (value) => ((value as boolean) ? '✔️' : '❌'),
                },
                naceLimitation: {
                    label: 'Beperkt tot NACE codes',
                    show: true,
                    getValue: (value) => (value as string[])?.join(', '),
                    getCsvExportValue: (value) => (value as string[])?.join(', '),
                    getExcelExportValue: (value) => (value as string[])?.join(', '),
                },
                requiredCertificateNumbers: {
                    label: 'Vereiste certificaat types',
                    show: true,
                    getValue: (value) => (value as string[])?.join(', '),
                    getCsvExportValue: (value) => (value as string[])?.join(', '),
                    getExcelExportValue: (value) => (value as string[])?.join(', '),
                },
            }}
            localizationSection={'certificate-type'}
            getUniqueKey={(item) => item.name}
            onRowClick={(item) =>
                dispatch(
                    setDestinationView({
                        destinationView: 'certificate-type-edit',
                        detailKey: item.name,
                    })
                )
            }
            isLoading={isLoading}
        />
    )
}
